module.exports = __webpack_public_path__ + "media/wyposazenie/audio-be94adff.png";